import * as _ from 'underscore';
import { StudioApplication } from '..';
import { ID, Icons } from '../../const';
import { Templates } from '../../compile';
import { View } from 'mappMvc/models/views';
import { BaseForm } from 'mappMvc/models/ui/forms';
import { Notification, Util } from 'mappMvc/models';
import { Label, Password, NotificationElement, Input, Button } from 'mappMvc/models/ui/uiElements';
import { ViewOptions } from 'mappMvc/interfaces/options';
import { KoExtensions } from 'mappMvc/extensions/ko';
import { KeyCode, NotificationType } from 'mappMvc/enums';
import { MetadataClient } from 'mappClient/metadataClient';
import { LoginError } from '../interface';
import { UserActivationClient, ActiveDirectoryClient } from 'mappClient/clients';
import { Localization } from 'mappMvc/compile';
import { IKeyValue } from 'mappMvc/interfaces';
import { ActiveDirectoryType } from '../../../MApp.Web.Client/enums';
import { MicrosoftLoginButton, OpenIdConnectLoginButton } from '../../../MApp.Web.Mvc/models/reactComponents/uiComponents'
import { ReactContainer } from '../../../MApp.Web.Mvc/models/ui/uiElements'



export class Login extends View {
	public name: KnockoutObservable<string>;
	public password: KnockoutObservable<string>;

	private form: BaseForm;
	private studio: StudioApplication;
	private notification: Notification;

	private infoLabelCtrl: Label;
	private passwordCtrl: Password;
	private submitLabel: KnockoutObservable<string>;
	private editableForm: KnockoutObservable<boolean>;

	constructor(options: ViewOptions) {
		super(
			_.defaults(options, <ViewOptions>{
				viewId: ID.Login,
				template: Templates.base_centered,
				label: Localization.Login.Login,
				icon: Icons.Security
			})
		);
		//hack to prevent studio/login url
		this.parent = null;
		this.studio = <StudioApplication>options.parent;
		this.name = KoExtensions.observable<string>();
		this.password = KoExtensions.observable<string>();
		this.notification = new Notification();
		this.submitLabel = ko.observable<string>(Localization.Login.Login);
		this.editableForm = ko.observable<boolean>(true);

		this.form = new BaseForm({
			initDefaultCommands: false,
			commands: [
				{
					command: () => this.form.submit(),
					label: this.submitLabel,
					css: Icons.Ok,
					template: Templates.forms_action
				}
			]
		});

		this.form.addUIElement(new NotificationElement('notification', null, this.notification, {}));

		this.form.addUIElement(
			new Input('name', Localization.Name, this.name, {
				template: Templates.layouts_uiElements_labelValidationWidget,
				rules: [{ rule: 'required', params: true }],
				css: 'validation-right',
				editable: this.editableForm
			})
		);

		this.passwordCtrl = new Password(
			'password',
			Localization.Login.Password,
			this.password,
			this.studio.allowResetPassword()
				? { click: this.showResetView, text: Localization.Login.ForgotPassword }
				: null,
			{
				rules: [{ rule: 'required', params: true }],
				css: 'validation-right',
				editable: this.editableForm
			}
		);
		this.form.addUIElement(this.passwordCtrl);

		const handleAzureLogin = (e) => {
			this.loginAzure(this.studio.getClientId());
		}

		const handleWsFedLogin = (e) => {
			this.loginWsFed(this.studio.getClientId());
		}

		const handleOpenIdConnectLogin = (e) => {
			this.loginOpenIdConnect(this.studio.getClientId());
		}

		let azureButton = new ReactContainer(
			"azureLoginButton",
			"Sign in with Microsoft",
			MicrosoftLoginButton,
			{
				theme: localStorage.getItem('dark-theme') === "true" ? "dark" : "light",
				clickHandler: handleAzureLogin
			}
		)

		let wsFedButton = new ReactContainer(
			"wsFedLoginButton",
			"Sign in with Microsoft",
			MicrosoftLoginButton,
			{
				theme: localStorage.getItem('dark-theme') === "true" ? "dark" : "light",
				clickHandler: handleWsFedLogin
			}
		)

		let openIdConnectButton = new ReactContainer(
			"openIdConnectButton",
			"Sign in with OpenID Connect",
			OpenIdConnectLoginButton,
			{
				theme: localStorage.getItem('dark-theme') === "true" ? "dark" : "light",
				clickHandler: handleOpenIdConnectLogin
			}
		)

		this.form.ClickedSubmit.subscribe((data: IKeyValue<any>) => {
			if (this.editableForm()) {
				this.login(data);
			}
		});

		this.ViewActivated.subscribe(() => {
			//handling redirect from azure/WsFed
			const urlParams = new URLSearchParams(window.location.search);
			const code = urlParams.get('code');
			const state = urlParams.get('state');

			if (code !== null && state !== null) {
				window.location.href = state + `&code=${code}`;
			}
			else if (code !== null && state === null && !MetadataClient.hasToken()) {
				this.editableForm(false);

				window.history.replaceState("", document.title, window.location.href.substring(window.location.href.indexOf("/"), window.location.href.indexOf("&code=")))

				this.notification.notify(Localization.Progress.Redirect, NotificationType.Success);

				MetadataClient.autoLoginActiveDirectory(code, MetadataClient.tenant, this.studio.getClientId()).then(
					() => {
						this.notification.notify(Localization.Progress.Redirect, NotificationType.Success);
						this.studio.loggedIn();
						this.editableForm(true);
					},
					(jqXHR: JQueryXHR) => {
						let error_description = Localization.Errors.LoginIncorrect;

						if (jqXHR.responseJSON && (<LoginError>jqXHR.responseJSON).error_description) {
							error_description = (<LoginError>jqXHR.responseJSON).error_description;
						}
						this.notification.notify(error_description, NotificationType.Error);
						this.editableForm(true);

						ActiveDirectoryClient.getActiveDirectoryType(MetadataClient.tenant).then(type => {
							if (type == ActiveDirectoryType.Azure) {
								this.form.addUIElement(azureButton);
							}
							else if (type == ActiveDirectoryType.WsFed) {
								this.form.addUIElement(wsFedButton);
							}
							else if (type == ActiveDirectoryType.OpenIdConnect) {
								this.form.addUIElement(openIdConnectButton);
							}
						});
					});
			}
			else {
				if (this.studio.getClientId() === "App") {
					ActiveDirectoryClient.getActiveDirectoryInfo(MetadataClient.tenant).then(info => {
						if (info.preferThirdPartyLogin) {
							if (info.type == ActiveDirectoryType.Azure) {
								this.loginAzure(this.studio.getClientId());
							}
							else if (info.type == ActiveDirectoryType.OpenIdConnect) {
								this.loginOpenIdConnect(this.studio.getClientId());
							}
						}
						else {
							if (info.type == ActiveDirectoryType.Azure) {
								this.form.addUIElement(azureButton);
							}
							else if (info.type == ActiveDirectoryType.WsFed) {
								this.form.addUIElement(wsFedButton);
							}
							else if (info.type == ActiveDirectoryType.OpenIdConnect) {
								this.form.addUIElement(openIdConnectButton);
							}
						}
					});
				}

				this.notification.hide();
				Util.setValue(null, this.password, this.name);
				this.form.hideValidationMessages();
				Util.bindKey(KeyCode.ENTER, this.form.submit, this.form);
				setTimeout(() => (<HTMLInputElement>document.querySelector('input#name')).focus(), 0);
			}
		});

		this.ViewDeactivated.subscribe(() => {
			Util.unbindKey(KeyCode.ENTER, this.form.submit);
		});
	}

	private login(formData: IKeyValue<any>): void {
		this.editableForm(false);
		this.notification.notify(Localization.Progress.Login, NotificationType.Hint);
		this.notification.show();
		MetadataClient.login(formData['name'], formData['password'], this.studio.getClientId()).then(
			() => {
				this.notification.notify(Localization.Progress.Redirect, NotificationType.Success);
				this.studio.loggedIn();
				this.editableForm(true);
			},
			(jqXHR: JQueryXHR) => {
				let error_description = Localization.Errors.LoginIncorrect;

				if (jqXHR.responseJSON && (<LoginError>jqXHR.responseJSON).error_description) {
					error_description = (<LoginError>jqXHR.responseJSON).error_description;
				}
				this.notification.notify(error_description, NotificationType.Error);
				this.editableForm(true);
			}
		);
	}

	private showResetView = () => {
		this.form.removeUIElement(this.passwordCtrl);
		this.form.setLabel(Localization.Login.ResetPassword);
		this.submitLabel(Localization.Login.ResetPassword);
		this.notification.setType(NotificationType.Hint);
		this.notification.setText(Localization.Login.InstructionMail);
		this.notification.show();

		this.form.ClickedSubmit.unsubscribeAll();
		this.form.ClickedSubmit.subscribe(this.resetPassword);
	};

	private resetLoginView = () => {
		this.form.addUIElement(this.passwordCtrl);
		this.form.setLabel(Localization.Login.Login);
		this.submitLabel(Localization.Login.LoginButton);
		this.form.ClickedSubmit.unsubscribeAll();
		this.form.ClickedSubmit.subscribe(this.login);
	};

	private resetPassword = () => {
		this.notification.notify(Localization.Progress.SendingRequest, NotificationType.Hint);
		this.notification.show();

		UserActivationClient.forgotPassword(this.name())
			.then(
				() => {
					this.notification.notify(Localization.Login.SendingDone, NotificationType.Success);
				},
				(jqXHR: JQueryXHR) => {
					let error_description = Localization.Login.SendingFailed;

					if (jqXHR.responseJSON && (<LoginError>jqXHR.responseJSON).error_description) {
						error_description = (<LoginError>jqXHR.responseJSON).error_description;
					}
					this.notification.notify(error_description, NotificationType.Error);
				}
			)
			.then(this.resetLoginView);
	};

	private loginWsFed(clientId: string): Promise<any> {
		alert("WsFed Login placeholder");
		return new Promise<any>(x => { });
	}


	private async loginAzure(clientId: string): Promise<any> {

		let metadata = await ActiveDirectoryClient.getAzureMetadata(MetadataClient.tenant);
		window.location.href = encodeURI(`https://login.microsoftonline.com/${metadata.tenantId}/oauth2/v2.0/authorize?` +
			`&client_id=${metadata.clientId}` +
			`&scope=User.Read` +
			`&response_type=code` +
			`&response_mode=query` +
			`&state=` + window.location.href);

		return new Promise<any>(() => { });
	}

	private async loginOpenIdConnect(clientId: string): Promise<any> {

		let metadata = await ActiveDirectoryClient.getOpenIdConnectMetadata(MetadataClient.tenant);
		window.location.href = encodeURI(metadata.authUrl +
			`?client_id=${metadata.clientId}` +
			`&response_type=code` +
			`&scope=openid profile email` +
			`&redirect_uri=` + window.location.href);

		return new Promise<any>(() => { });
	}

}
